import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MockDataPreview } from '../interfaces/mock-data-preview.interface';
import { MockDataDeleteRequestModel } from '../interfaces/mock-data-delete-request-model.interface';
import { MockDataTransferRequestModel } from '../interfaces/mock-data-transfer-request-model.interface';
import { MockDataDownloadRequestModel } from '../interfaces/mock-data-download-request-model.interface';
import { MockDataUploadRequestModel } from '../interfaces/mock-data-upload-request-model.interface';
import { FileInformation, UploadHelper } from '@asamco/application-link/shared';
import { combineLatest, concatMap, filter, from, map, of, switchMap } from 'rxjs';
import { showErrorSwal } from '@asamco/utils';

@Injectable({
	providedIn: 'root',
})
export class MockDataService {
	url: string = 'mockData';

	loadedFiles: File[];

	constructor(private http: HttpClient) {}

	public getDomainPreview(sourceSystem: string) {
		return this.http.get<MockDataPreview[]>(`${this.url}/getDomainPreview/${sourceSystem}`);
	}

	public deleteMockData(model: MockDataDeleteRequestModel) {
		return this.http.post<any[]>(`${this.url}/DeleteMockData`, model);
	}

	public transferMockData(model: MockDataTransferRequestModel) {
		return this.http.post<any[]>(`${this.url}/TransferMockData`, model);
	}

	public downloadMockData(model: MockDataDownloadRequestModel) {
		return this.http.post<any>(`${this.url}/downloadMockData`, model);
	}

	uploadMockData(model: MockDataUploadRequestModel) {
		model.file = <any>{
			fileName: this.loadedFiles[0].name,
			contentType: this.loadedFiles[0].type
		};
		return this.http.post<MockDataUploadRequestModel>(`${this.url}/prepareUpload`, model).pipe(
			concatMap(rcm => from(UploadHelper.uploadFiles([rcm.file], this.loadedFiles)).pipe(switchMap(r => this.http.post<MockDataUploadRequestModel>(`${this.url}/storeUploadedMockData`, rcm))))
		);
	}
}
